<template>
  <div class="user-page">
    <div class="uk-grid-medium" uk-grid>
      <div class="uk-width-5-5">
        <PageHeader :title="$t('general.notifications')" icon="uil-bell" />
        <template v-if="errorMessages">
          <div
              v-for="(error, index) in errorMessages"
              :key="index"
              class="notification-alert notification-alert--danger"
          >
            <button class="notification-alert__close" @click="errorMessages.splice(index, 1)">
              <i class="uil-times"></i>
            </button>
            <p class="notification-alert__text">
              <i class="uil-exclamation-triangle"></i> {{ error }}
            </p>
          </div>
        </template>
        <NotificationTabs>
          <ul id="notification-tab-content" class="uk-switcher ad-tab-content">
            <li>
              <NotificationList @error="onError"/>
            </li>
            <li>
              <ActionList @error="onError"/>
            </li>
          </ul>
        </NotificationTabs>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/view/components/common/PageHeader.vue";
import NotificationTabs from "./components/NotificationTabs.vue";
import NotificationList from "./components/NotificationList.vue";
import ActionList from "./components/ActionList.vue";

export default {
  name: "Notification",
  components: {
    PageHeader,
    NotificationTabs,
    NotificationList,
    ActionList,
  },
  data() {
    return {
      errorMessages: [],
    };
  },
  methods: {
    onError(message) {
      this.errorMessages.push(message);
    },
    resetMessages() {
      this.errorMessages = [];
    },
  },
  created() {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
  watch: {
    errorMessages() {
      this.debouncedResetValues();
    },
  },
};
</script>

<style scoped>
.user-page {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.ad-tab-content {
  margin: 0;
  padding: 0;
}

.ad-tab-content > li {
  padding: 24px;
}

@media (max-width: 768px) {
  .ad-tab-content > li {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .ad-tab-content > li {
    padding: 12px;
  }
}

.notification-alert {
  position: relative;
  padding: 14px 44px 14px 16px;
  border-radius: 10px;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
}

.notification-alert--danger {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
}

.notification-alert__close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  color: #dc2626;
  cursor: pointer;
  font-size: 16px;
  padding: 2px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.notification-alert__close:hover {
  opacity: 1;
}

.notification-alert__text {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-alert__text i {
  font-size: 16px;
}

@media (max-width: 768px) {
  .user-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .user-page :deep(.page-header-block),
  .user-page :deep(.page-header-block__left),
  .user-page :deep(.page-header-block__title) {
    min-width: 0;
  }

  .user-page :deep(.page-header-block) {
    gap: 8px;
  }

  .user-page :deep(.page-header-block__title) {
    font-size: 18px;
  }

  .notification-alert__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    top: 6px;
    right: 6px;
    padding: 0;
  }
}
</style>
